module.exports = __webpack_public_path__ + "img/default-bee.637f1368.svg";